import { createContext, useEffect, useMemo, useState, type ReactNode } from "react"

interface ThemeContextValue {
  themeName: string
  toggleTheme: () => void
}

export const ThemeContext = createContext<ThemeContextValue>({
  themeName: "dark",
  toggleTheme: () => {},
})

function ThemeProvider({ children }: { children: ReactNode }) {
  const [themeName, setThemeName] = useState<string>(() => {
    return localStorage.getItem("themeName") || "dark"
  })

  useEffect(() => {
    localStorage.setItem("themeName", themeName)
  }, [themeName])

  const toggleTheme = () => {
    setThemeName((prevTheme) => prevTheme === "dark" ? "light" : "dark")
  }

  const contextValue = useMemo(
    () => ({ themeName, toggleTheme }),
    [themeName]
  )

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  )
}

export { ThemeProvider }
